export default "__VITE_ASSET__C6zyl_$S__"